import React from "react";
import { Modal, ModalContent } from "@dealer-center/core-components";
import styled from "styled-components";

const StyledMessage = styled.div`
  background-color: #f2f3f3;
  padding: 10px;
  width: 100%;
`;

interface WarningModalProps {
  show: boolean;
  onHide: () => void;
}

export const WarningModal = ({ onHide, show }: WarningModalProps) => (
  <Modal header={"Warning!"} show={show} size="large" onHide={onHide}>
    <ModalContent>
      <StyledMessage>
        <p>
          Any changes made in this tool will autosave and affect our display of
          global vehicle data across the website platform. The only team members
          that should be making changes in this application are the Dealer.com
          Industry Data Team! If you have questions regarding display of global
          vehicle data, please send inquiries to IDT.Analysts@dealer.com.
        </p>
        <p>This modal will appear again in 7 days.</p>
      </StyledMessage>
    </ModalContent>
  </Modal>
);
